
  import { defineComponent } from 'vue';

  import SwitchTab from '@/common/components/redesigned/Tabs/SwitchTab.vue';

  import StatisticsPdfTitle from './StatisticsPdfTitle.vue';

  const DEFAULT_PDF_TITLE = 'По периодам';

  export default defineComponent({
    name: 'StatisticsBaseSwitchTab',
    components: {
      SwitchTab,
      StatisticsPdfTitle,
    },
    props: {
      textTrue: {
        type: String,
        required: true,
      },
      textFalse: {
        type: String,
        required: true,
      },
      pdfFirstTitle: {
        type: String,
        default: DEFAULT_PDF_TITLE,
      },
      pdfSecondTitle: {
        type: String,
        default: DEFAULT_PDF_TITLE,
      },
      defaultSelectSecondTab: {
        type: Boolean,
        default: false,
      },
    },
  });
